import { type SurveyModel } from "survey-core";

type RegisterDegreeQuestionOnSubmitProps = {
  model: SurveyModel;
  formData?: unknown;
};

const normalizeDegreeQuestionOnSubmit = ({
  sender,
  formData,
  degreeQuestionNames,
}: {
  sender: SurveyModel;
  formData: Record<string, unknown>;
  degreeQuestionNames: string[];
}) => {
  if (degreeQuestionNames.length === 0) {
    return;
  }

  const senderData = {
    ...(sender.data as Record<string, unknown>),
  };

  degreeQuestionNames.forEach((questionName) => {
    const hadInitialDegreeData = Object.prototype.hasOwnProperty.call(
      formData,
      questionName,
    );

    if (hadInitialDegreeData && senderData[questionName] === undefined) {
      senderData[questionName] = [];
    }
  });

  sender.data = senderData;
};

export const registerDegreeQuestionOnSubmit = ({
  model,
  formData,
}: RegisterDegreeQuestionOnSubmitProps) => {
  if (!formData || typeof formData !== "object" || Array.isArray(formData)) {
    return;
  }

  const degreeQuestionNames = Array.from(
    new Set(
      model
        .getAllQuestions()
        .filter((question) => question.getType() === "degree_picker")
        .map((question) => question.getValueName()),
    ),
  );

  model.onComplete.add((sender) => {
    normalizeDegreeQuestionOnSubmit({
      sender,
      formData: formData as Record<string, unknown>,
      degreeQuestionNames,
    });
  });
};
